module.exports = __webpack_public_path__ + "img/icon-discord.6ab34e5b.svg";